// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"LayerHeaderItem_tooltip__26x9v","switchRoot":"LayerHeaderItem_switchRoot__1dWr7"};